const LEGACY_ID_PREFIX = 'legacy_';
const GENERATED_ID_PREFIX = 'prop_';

function isNonEmptyString(value) {
    return typeof value === 'string' && value.trim().length > 0;
}

function toNullableString(value) {
    if (value == null) return null;
    return String(value);
}

function resolvePropertyId(rawItem) {
    if (isNonEmptyString(rawItem?.propertyId)) return rawItem.propertyId;
    if (isNonEmptyString(rawItem?.property)) return rawItem.property;
    return null;
}

function buildLegacyFallbackId(rawItem, index) {
    const fallbackSeed = resolvePropertyId(rawItem) || 'unknown';
    return `${LEGACY_ID_PREFIX}${index}_${fallbackSeed}`;
}

export function generatePropertyItemId() {
    const randomPart = Math.random().toString(36).slice(2, 10);
    return `${GENERATED_ID_PREFIX}${Date.now()}_${randomPart}`;
}

export function normalizePropertyItem(rawItem, index = 0) {
    const safeItem = rawItem && typeof rawItem === 'object' ? rawItem : {};
    const normalizedId = isNonEmptyString(safeItem.propertyItemId)
        ? safeItem.propertyItemId
        : buildLegacyFallbackId(safeItem, index);
    const propertyId = resolvePropertyId(safeItem);

    return {
        ...safeItem,
        ...(propertyId ? {propertyId} : {}),
        propertyItemId: normalizedId,
    };
}

export function normalizePropertyItemsForRead(items) {
    if (!Array.isArray(items)) return [];
    return items.map((item, index) => normalizePropertyItem(item, index));
}

export function sanitizePropertyItemForWrite(rawItem, index = 0, idGenerator = generatePropertyItemId) {
    const safeItem = rawItem && typeof rawItem === 'object' ? rawItem : {};
    const fallbackId = isNonEmptyString(safeItem.propertyItemId)
        ? safeItem.propertyItemId
        : idGenerator(index, safeItem);

    return {
        propertyItemId: fallbackId,
        propertyId: resolvePropertyId(safeItem),
        propertyLabel: toNullableString(safeItem.propertyLabel),
        value: toNullableString(safeItem.value),
        valueEntityId: toNullableString(safeItem.valueEntityId),
    };
}

export function sanitizePropertiesDocumentForWrite(input) {
    const isDocShape = input && typeof input === 'object' && !Array.isArray(input);
    const rawItems = isDocShape ? input.items : input;
    const revisionValue = isDocShape ? input.revision : undefined;

    const items = Array.isArray(rawItems)
        ? rawItems.map((item, index) => sanitizePropertyItemForWrite(item, index))
        : [];

    const revision = Number.isInteger(revisionValue) && revisionValue >= 0 ? revisionValue : 0;

    return {items, revision};
}
